<template>
	<div id="product-description-page">

		<section class="main-description-section">
			<b-form @submit="onSubmit" class="container oversized-container">
				
				<breadcrumbs :crumbs="[{link: '/', label: 'Inicio'}, {link: '/equipos', label: 'Equipos'}, { label: product.nombre }]"/>
				
				<div class="row">
					<div class="col-lg-6 col-gallery">
						<swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
							<swiper-slide>
								<api-img :comp="product.imagenes_id" />
							</swiper-slide>

							<div class="swiper-button-next" slot="button-next"></div>
							<div class="swiper-button-prev" slot="button-prev"></div>
						</swiper>
					</div>

					<div class="col-lg-5 mt-4 mt-lg-0 col-info">
						<h1 class="title">{{ product.nombre }}</h1>

						<h4 class="price">{{ product.precio | currency }} MXN</h4>

						<div class="row">
							<div class="mb-2 col-12">
								<h6 class="txt-features"><strong class="sub-label">Disponibilidad:</strong> {{
									product.existencia > 0 ? 'En stock' : 'Sin stock'}}</h6>
							</div>
							<div class="col-lg-6">
								<h6 class="txt-features"><strong class="sub-label">Modelo:</strong> {{ product.modelo }}
								</h6>
							</div>
							<div class="col-lg-6">
								<h6 class="txt-features"><strong class="sub-label">Marca:</strong> {{ product.marca }}
								</h6>
							</div>
						</div>

						<h6 class="mt-4 subtitle">Especificaciones</h6>
						<div class="mb-4 descr">
							<p>{{ product.descripcion }}</p>
						</div>

						<h6 class="mb-1 subtitle">Cantidad</h6>
						<div class="mb-4 row">
							<div class="col-4 col-sm-3 col-md-2">
								<b-form-input class="custom-lg-input text-center" type="number" readonly min="1"
									v-model="quantity" required></b-form-input>
							</div>
						</div>

						<!-- <h6 class="mb-1 subtitle">Modelo</h6> -->
						<div class="row">
							<div class="col-sm-5 mt-2 mt-sm-0">
								<b-button type="submit" class="btn-add" v-if="product.existencia >= quantity">
									Agregar
								</b-button>
								<b-button class="" v-else disabled>Próximamente</b-button>
							</div>
						</div>

					</div>
				</div>
			</b-form>
		</section>

	</div>
</template>

<script>
import Breadcrumbs from '../daniel/breadcrumbs'
import _ from 'lodash'
import { mapActions, mapGetters } from "vuex";
import mobiscroll from "@mobiscroll/javascript";
import swal from 'sweetalert';
export default {
  components: { Breadcrumbs },
	name: 'ProductDescriptionPage',
	data() {
		return {
			quantity: 1,

			product: {
				nombre: "Celular Samsung A12 5ta generación",
				sku: "6562SM5",
				peso_neto: "200",
				images: [
					{ url: "public/images/pages/products/product-2.jpg" },
					{ url: "public/images/pages/products/product-2.jpg" },
				],
			},

			// == Carousels options ==
			swiperOptionTop: {
				loop: true,
				loopedSlides: 5, // looped slides should be the same
				spaceBetween: 10,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			// == ==
		};
	},

	computed: {
		...mapGetters(["catalogosGetProductos"]),
	},

	methods: {
		...mapActions(['cartAddItem']),
		async getProduct() {
			try {
				this.product = _.find(this.catalogosGetProductos, { id: this.$route.params.id })
			} catch (e) {
				console.error(e);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message: "Ocurrió un error obteniendo la respuesta: " + e,
					color: "warning",
					duration: 7000,
				});
			}
		},
		async onSubmit(event) {
			event.preventDefault();
			await this.cartAddItem(this.product.id)
			let swalResponse = await swal({
				icon: 'success',
				title: 'Agregado exitosamente al carrito',
				buttons: {
					cancel: 'Continuar',
					primary: 'Ir al carrito'
				}
			})
			if (swalResponse == 'primary') {
				this.$router.push('/cart')
			}
		},
	},

	mounted() {
		this.getProduct();
	},

	watch: {
		"$route.params.id": function (v) {
			// this.id = this.$root._getURLID(this.$route.params.id);
			this.getProduct();
		},
	},
};
</script>
